import { useLocation } from "react-router-dom";
import { Col, Collapse, Row } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp } from "@fortawesome/pro-regular-svg-icons";

import { GET } from "../../../providers/useAxiosQuery";
import CollapseItemGradeFileReportDetails from "./components/CollapseItemGradeFileReportDetails";
import CollapseItemFacultyLoadReportDetails from "./components/CollapseItemFacultyLoadReportDetails";
import CollapseItemGradeFileApprovedReportDetails from "./components/CollapseItemGradeFileApprovedReportDetails";

export default function PageGradeFileReports() {
	const location = useLocation();

	const { data: dataDepartments } = GET(
		`api/department_dropdown?sort_field=department_name&sort_order=asc`,
		"department_dropdown",
		(res) => {},
		false
	);

	const { data: dataSchoolYear } = GET(
		`api/school_year?sort_field=sy_to&sort_order=asc`,
		"school_year_dropdown",
		() => {},
		false
	);
	const { data: dataSemester } = GET(
		`api/semester?sort_field=semester&sort_order=asc`,
		"semester_dropdown",
		() => {},
		false
	);

	return (
		<Row gutter={[20, 20]}>
			<Col xs={24} sm={24} md={24} lg={24}>
				<Collapse
					defaultActiveKey={["1", "2", "3", "4"]}
					expandIconPosition="end"
					expandIcon={({ isActive }) =>
						isActive ? (
							<FontAwesomeIcon icon={faAngleUp} />
						) : (
							<FontAwesomeIcon icon={faAngleDown} />
						)
					}
					className="collapse-main-primary"
					items={[
						{
							key: "1",
							className: "collapse-main-primary",
							label: `Grade File Report Details`,
							children: (
								<CollapseItemGradeFileReportDetails
									location={location}
									dataDepartments={
										dataDepartments && dataDepartments.data
											? dataDepartments.data
											: []
									}
									dataSchoolYear={
										dataSchoolYear && dataSchoolYear.data
											? dataSchoolYear.data
											: []
									}
									dataSemester={
										dataSemester && dataSemester.data ? dataSemester.data : []
									}
								/>
							),
						},
						{
							key: "2",
							className: "collapse-main-primary",
							label: `Grade File Report Details (By Count)`,
							children: (
								<CollapseItemFacultyLoadReportDetails
									location={location}
									dataDepartments={
										dataDepartments && dataDepartments.data
											? dataDepartments.data
											: []
									}
									dataSchoolYear={
										dataSchoolYear && dataSchoolYear.data
											? dataSchoolYear.data
											: []
									}
									dataSemester={
										dataSemester && dataSemester.data ? dataSemester.data : []
									}
								/>
							),
						},
						{
							key: "3",
							className: "collapse-main-primary",
							label: `Grade File Report Details (File Approved)`,
							children: (
								<CollapseItemGradeFileApprovedReportDetails
									location={location}
									dataDepartments={
										dataDepartments && dataDepartments.data
											? dataDepartments.data
											: []
									}
									dataSchoolYear={
										dataSchoolYear && dataSchoolYear.data
											? dataSchoolYear.data
											: []
									}
									dataSemester={
										dataSemester && dataSemester.data ? dataSemester.data : []
									}
								/>
							),
						},
					]}
				/>
			</Col>
		</Row>
	);
}
